import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FORM_MODE } from 'shared/enums';
import { clearMailingRule } from 'modules/mailingRule';

interface IMailingRuleNavigationModeState {
  mode: FORM_MODE;
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
}

const initialState = {
  mode: FORM_MODE.list,
  loading: 'idle',
} as IMailingRuleNavigationModeState;

export const setSelectedMailingRuleModeAction = createAsyncThunk<
  FORM_MODE,
  FORM_MODE
>('mailingRuleModeNavigation', async (payload: FORM_MODE, { dispatch }) => {
  if (payload === FORM_MODE.create) {
    dispatch(clearMailingRule());
  }
  if (payload === FORM_MODE.list) {
    dispatch(
      mailingRuleNavigationModeSlice.actions.resetMailingRuleModeAction(),
    );
  }
  return payload;
});

const mailingRuleNavigationModeSlice = createSlice({
  name: 'mailingRuleModeNavigation',
  initialState,
  reducers: {
    resetMailingRuleModeAction(state) {
      state = Object.assign({}, initialState);
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSelectedMailingRuleModeAction.pending, (state) => {
      state.loading = 'pending';
    });
    builder.addCase(
      setSelectedMailingRuleModeAction.fulfilled,
      (state, action) => {
        state.mode = action.payload;
        state.loading = 'idle';
      },
    );
  },
});
const { reducer, actions } = mailingRuleNavigationModeSlice;
export const { resetMailingRuleModeAction } = actions;
export default reducer;
